import { render, staticRenderFns } from "./CdlSaude.vue?vue&type=template&id=34282d98&scoped=true&"
import script from "./CdlSaude.vue?vue&type=script&lang=js&"
export * from "./CdlSaude.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaude.vue?vue&type=style&index=0&id=34282d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34282d98",
  null
  
)

export default component.exports